import { Params } from '@angular/router';
import { OrderedSet } from 'immutable';
import { EventSearchFilter } from '../models/event-filter';

export class SearchEventUtils {

  static convertParamsToSearchTextSet(queryParams: Params): OrderedSet<string> {
    const searchQueryParams = queryParams['search'];
    if (searchQueryParams) {
      const searchTextArray: string[] = searchQueryParams instanceof Array ? searchQueryParams : [searchQueryParams];
      return OrderedSet(searchTextArray);
    } else {
      return OrderedSet([]);
    }
  }

  static convertParamsToSearchFilterSet(queryParams: Params): OrderedSet<EventSearchFilter> {
    let filterParams = queryParams['filters'];
    return this.convertStringToSearchFilterSet(filterParams);
  }

  static convertStringToSearchFilterSet(filterParams: string): OrderedSet<EventSearchFilter> {
    let filterSet = OrderedSet<EventSearchFilter>([]);
    let jsonParams;
    try {
      jsonParams = JSON.parse(filterParams);
    } catch (e) {
      return filterSet;
    }
    const searchFilterArray: EventSearchFilter[] = jsonParams instanceof Array ? jsonParams : [jsonParams];
    searchFilterArray.forEach((eachFilter) => {
      if (eachFilter.filterField && eachFilter.filterValue) {
        const filterField = eachFilter.filterField;
        const filterValue = eachFilter.filterValue;
        const filter = new EventSearchFilter({
          filterField: filterField,
          filterValue: filterValue
        });
        filterSet = filterSet.add(filter);
      }
    });
    return filterSet;
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/utils/search-event-utils.ts